export default __webpack_public_path__ + "static/media/Heroku.c74bee02.svg";